import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

import { Tooltip } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

export const AltAssetTableHeader = ({
  isHotmaActive = false,
  intl,
  householdAssetThreshold = 50000,
  withRowNumber = false,
  isBankDataRequired = false,
  stateRules = null,
  largeInputColSize,
  mediumInputColSize,
  smallInputColSize,
  annualIncomeColSize,
  actualImputeColSize,
  assetVerificationColSize,
}) => {
  const typeOfAssetColSize = isBankDataRequired ? 2 : largeInputColSize;
  const resolvedAnnualIncomeColSize = annualIncomeColSize ?? largeInputColSize;
  const resolvedActualImputeColSize = actualImputeColSize ?? largeInputColSize;
  const resolvedAssetVerificationColSize =
    assetVerificationColSize ?? largeInputColSize;

  return (
    <div className="row faux-table__head">
      <div className={`col-xs-${typeOfAssetColSize}`}>
        <div className="row">
          {withRowNumber && (
            <div className="col-xs-3">
              <label>#</label>
            </div>
          )}
          <div className="col-xs-9">
            <label>
              <FormattedMessage {...messages.typeOfAsset} />
            </label>
          </div>
        </div>
      </div>
      <div className={`col-xs-${smallInputColSize} text-center`}>
        <div className="row">
          <div className="col-xs-12">
            <label>
              <FormattedMessage {...messages.currentlyOwn} />
            </label>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <label>
              <FormattedMessage {...messages.no} />
            </label>
          </div>
          <div className="col-xs-6">
            <label>
              <FormattedMessage {...messages.yes} />
            </label>
          </div>
        </div>
      </div>
      {isBankDataRequired && (
        <>
          <div className={`col-xs-${mediumInputColSize}`}>
            <label>
              <FormattedMessage {...messages.bankSource} />
            </label>
          </div>
          <div className={`col-xs-${mediumInputColSize}`}>
            <label>
              <FormattedMessage {...messages.accountNumber} />
            </label>
          </div>
        </>
      )}
      <div className={`col-xs-${mediumInputColSize}`}>
        <label>
          <FormattedMessage {...messages.marketValue} />
        </label>
      </div>
      <div className={`col-xs-${smallInputColSize}`}>
        <label>
          <FormattedMessage {...messages.interestRate} />
        </label>
      </div>
      <div className={`col-xs-${mediumInputColSize}`}>
        <label>
          <FormattedMessage {...messages.feesToCash} />
        </label>
      </div>
      <div className={`col-xs-${mediumInputColSize}`}>
        <label>
          <FormattedMessage {...messages.cashValue} />
        </label>
      </div>
      <div className={`col-xs-${resolvedAnnualIncomeColSize}`}>
        <label>
          <FormattedMessage {...messages.annualIncome} />
        </label>
      </div>
      {stateRules?.requiresAssetVerification && (
        <div className={`col-xs-${resolvedAssetVerificationColSize}`}>
          <label>{stateRules.assetVerificationColumnLabel}</label>
        </div>
      )}
      {isHotmaActive && (
        <div className={`col-xs-${resolvedActualImputeColSize}`}>
          <label>
            <FormattedMessage {...messages.actualImpute} />
          </label>
          <Tooltip
            title={intl.formatMessage(messages.actualImputeTooltip, {
              householdAssetThreshold: intl.formatNumber(
                householdAssetThreshold,
                {
                  style: 'currency',
                  currency: 'USD',
                },
              ),
            })}
            arrow
            placement="top"
            style={{
              display: 'inline-flex',
              marginLeft: '2px',
              verticalAlign: 'middle',
            }}
            variant="light"
          >
            <AlertInfoIcon />
          </Tooltip>
        </div>
      )}
      {stateRules?.requiresAssetVerification && (
        <div className="col-xs-1 faux-table__head-actions" aria-hidden />
      )}
    </div>
  );
};
